import { Children, createContext, useState } from "react";
import styled from "styled-components";
import Home from "../Content/Home/Home";
import Thankyou from "../Content/Thankyou/Thankyou";

const PageContext = createContext();

const PageProvider = ({children}) => {

    const listaRespostas = []

    for(let i = 0; i < 124; i++) {
        listaRespostas.push([0,0,0,0,0,0,0])
    }

    const [answerList, setAnswerList] = useState(listaRespostas);
    const [page, setPage] = useState(<Home/>);

    const [nome, setNome] = useState("");
    const [profissao, setProfissao] = useState("Medicina");
    const [email, setEmail] = useState("");
    const [codigo, setCodigo] = useState("XYZ2026");

    return(
        <PageContext.Provider 
        value={{
            answerList, setAnswerList,
            page, setPage,
            nome, setNome,
            profissao, setProfissao,
            email, setEmail,
            codigo, setCodigo
        }}>
            {children}
        </PageContext.Provider>
    )
}

export {PageContext, PageProvider};
